import { render } from "./PaginationSelect.vue?vue&type=template&id=82919afa&scoped=true"
import script from "./PaginationSelect.vue?vue&type=script&lang=js"
export * from "./PaginationSelect.vue?vue&type=script&lang=js"

import "./PaginationSelect.vue?vue&type=style&index=0&id=82919afa&scoped=true&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82919afa"]])

export default __exports__